export class ShareLink {
    buttons: NodeListOf<Element>;
    button: HTMLElement;
    link: HTMLLinkElement;

    constructor() {
        this.buttons = document.querySelectorAll('[data-share-link]');
        this.init();
    }

    init() {
        this.addEventListeners();
    }

    addEventListeners() {
        this.buttons.forEach((button) => {
            button.addEventListener('click', (event) => {
                const link = button.getAttribute("href");
                navigator.clipboard.writeText(link);
                event.preventDefault();
                button.classList.add("c-button--secondary");
                button.innerHTML = "Der Link wurde in die Zwischenablage kopiert";
            });
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new ShareLink();
});
